import { FlexLayout } from '@deity/falcon-ui';
import type { FC } from 'react';
import NativeInputControl from './NativeInputControl';

interface FieldEditorProps {
  isEditable: boolean;
  intValue: number | string | boolean | undefined;
  property: string;
  inputControl: string;
  notEmpty: boolean;
  required: boolean;
  description?: string;
  onChange: (key: string, value: any) => void;
  onBlur?: (key: string, value: any) => void;
  isPassword?: boolean;
}
export const FieldEditor: FC<FieldEditorProps> = ({
  isEditable,
  intValue,
  property,
  notEmpty,
  required,
  inputControl,
  description,
  onChange,
  onBlur,
  isPassword = false
}) => (
  <FlexLayout p="xs" mt="xs" mb="xs" bg="panelLight" borderRadius="small" css={{ minHeight: '78px' }} width="full">
    <NativeInputControl
      isEditable={isEditable}
      description={description}
      notEmpty={notEmpty}
      required={required}
      value={intValue}
      property={property}
      controlType={inputControl}
      onValueChange={(key, val) => onChange(key, val)}
      onBlur={(key, val) => onBlur && onBlur(key, val)}
      isPassword={isPassword}
    />
  </FlexLayout>
);

export default FieldEditor;
